import React from "react";

const Project = ({img, link}) => {
  return (
    <div className="card w-1/3 md:h-64 h-40 mt-4 mb-11 mx-3 border-2 border-pink-600 rounded-b-xl bg-pink-500 overflow-hidden ">
      <div className="card-browser h-auto bg-gray-400 flex items-center gap-2 pl-1 py-1 hover:translate-y-7 ">
        <div className="b-circle w-2 h-2 bg-white rounded-full >"></div>
        <div className="b-circle w-2 h-2 bg-white rounded-full >"></div>
        <div className="b-circle w-2 h-2 bg-white rounded-full >"></div>
      </div>
      <a href={link} target="_blank" rel="noreferrer">
        <img src={img} alt="" className="p-img w-full transition-all duration-1000 ease-linear hover:-translate-y-16" />
      </a>
    </div>
  );
};

export default Project;
